<nb-card
	[nbSpinner]="true"
	nbSpinnerSize="giant"
	nbSpinnerStatus="primary"
	nbSpinnerMessage="Loading"
>
</nb-card>
